<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view />
    <!-- intentionally added this condition to follow child routes -->
    <v-col v-if="$route.name === 'licenseManager'">
      <v-row no-gutters>
        <v-col md="2"><h2 class="title-1 ml-5 primary-text">License Managers</h2></v-col>
        <v-col class="text-right">
          <v-btn icon @click="resetAll" class="mr-1">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getLicencesList(),pageReset()"
          />
          <v-select
            v-model="selectedRole"
            class="custom-select"
            :item-text="(item) => item.role_name"
            :items="licenseManagersList"
            :item-value="(item) => item.id"
            label="Role"
            append-icon="expand_more"
            multiple
            solo
            attach
            @change="getLicencesList"
          />
          <!-- <v-btn icon class="primary-icon mr-3">
        <v-icon size="32">filter_alt</v-icon>
      </v-btn> -->
      <v-btn
        depressed
        class="primary_btn small"
        @click="$router.push({ name: 'addLicenceManager' })"
        >Add License Manager</v-btn
      >
        </v-col>
      </v-row>
      
    </v-col>
    <v-col v-if="$route.name === 'licenseManager'" class="custom-panel">
      <div v-if="loading" style="text-align:center; margin-top: 16px;">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      <v-data-table
        v-show="!loading"
        id="licenses"
        :headers="headers"
        :items="licenseManagerList.data"
        :options.sync="options"
        :server-items-length="licenseManagerList.total"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
        :sort-desc.sync="sortDesc"
        :header-props="{ 'sortIcon': 'arrow_upward' }"
        @update:sort-desc="getLicencesList"
        
      >
        <template v-slot:item.created_at="{ item }">
          {{ moment(item.created_at) }}
        </template>
        <template v-slot:item.name="{ item }">
            <b>
            {{ item.name }}</b>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn icon>
                <v-icon
                  @click="
                    $router.push(
                      `/license-manager/edit-licence-Manager/${item.id}`,
                    )
                  "
                  >edit</v-icon
                >
              </v-btn>
              <!-- <edit-licence/> -->
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination :total="licenseManagerList.total" :value="page" @input="pageEmit" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import LicensePagination from '@/components/LicensePagination/licensePagination.vue'
import { storeActions } from '../../store/actions.constants';
export default {
  components:{
    LicensePagination,
  },
  data: () => ({
    loading: true,
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      { text: 'Email', value: 'email' },
      { text: 'Role', value: 'role_name' },
      { text: 'Date Added', value: 'created_at' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    totalusers: 0,

    options: {},
    page: 1,
    itemsPerPage: 10,
    selectedRole: null,
    rolesList:[],
    sortDesc:[],
  }),
  computed: {
    ...mapGetters({
      licenseManagerList: 'addLicenseManager/getLicenseManagers',
    }),
    //  pageCount() {
    //   return Math.ceil(this.licenseManagerList.total / this.itemsPerPage)
    //   },
      licenseManagersList() {
      return this.rolesList.filter((role) => ({
        roleName: role.role_name,
        id:role.id,
      }))
     },
  },
  // watch: {
  //   options: {
  //     handler() {
  //     if(this.options.page !== undefined)   this.getLicencesList();
  //     },
  //     deep: true,
  //   },
  // },
  async mounted() {
    this.loading = true;
   if(this.options.page!== undefined) await this.getLicencesList();
   let res= await this.getRoleList();
   this.rolesList= res.data;
   this.loading = false;
  },
  methods: {
    ...mapActions({
      getLicenseManagers: 'addLicenseManager/getLicenseManagerDetails',
      getRoleList: 'addLicenseManager/getRoleList',
     }),
     pageReset() {
      if(this.search) {
        this.page=1;
      }
    },
      pageEmit(data) {
      if(data>0) {
        this.page=data;
      }
      this.getLicencesList();
    },
     resetAll() {
      this.search='';
      this.page=1;
      this.selectedRole= null;
      this.getLicencesList();
    },
    getLicencesList() {
      if(this.selectedRole) {
        this.page=1;
      }
      const { sortBy, sortDesc} = this.options;
      this.getLicenseManagers({
        page:this.page,
        limit: 10,
        search: this.search ||'',
        id: this.selectedRole?this.selectedRole.join(','):'',
        sort:sortBy[0],
        desc:this.sortDesc[0] ||0,
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            console.log(items)
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          console.error(err);
        });
    },
    moment: function(value) {
      return moment(value).format('DD/MM/YYYY');
    },
  },
};
</script>
